import { useMemo, useState } from "react";
import useSystemConfiguration from "../../../../hooks/useSystemConfiguration";

const useAddCategoryPopup = ({ popupData, closePopup }) => {
  const [value, setValue] = useState("");
  const onSubmit = popupData?.onSubmit;
  const isAdminPage = popupData?.isAdminPage;
  const preferenceType = popupData?.preferenceType;
  const currentUserPreferences = popupData?.preferences;
  const { data: adminPreferences } = useSystemConfiguration();

  const confirm = () => {
    if (isAdminPage) {
      onSubmit(value);
    } else {
      onSubmit(value, preferenceType);
    }
    setValue("");
    closePopup();
  };

  const isDisabled = useMemo(() => {
    // if value typed and is on admin page
    if (value && isAdminPage) {
      const list = Object.keys(adminPreferences?.system?.preferences).map(
        (item) => item?.toLowerCase() ?? []
      );
      return list?.includes(value?.toLowerCase());
    }
    // if on user contact let them select from dropdown
    // as long as they don't already have the container under that preference type
    if (!isAdminPage && value) {
      const list = Object.keys(currentUserPreferences?.[preferenceType])?.map(
        (item) => item?.toLowerCase() ?? []
      );
      return list?.includes(value?.toLowerCase());
    }
    return false;
  }, [
    adminPreferences?.system?.preferences,
    currentUserPreferences,
    isAdminPage,
    preferenceType,
    value,
  ]);

  const selectCategory = (category) => {
    if (!isAdminPage) {
      setValue("");
      setValue(category);
    }
  };
  const preferenceList = !isAdminPage
    ? Object.keys(currentUserPreferences?.[preferenceType])
    : Object.keys(adminPreferences?.system?.preferences);

  return {
    confirm,
    value,
    setValue,
    isDisabled,
    adminPreferences: adminPreferences?.system?.preferences,
    isAdminPage,
    selectCategory,
    preferenceList,
  };
};

export default useAddCategoryPopup;
